export class LinkRecipeWithCustomerRecipeInput {
  orderId: number;
  customerRecipeId: number;
}